module.exports = __webpack_public_path__ + "img/j3.8780355.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/j3.jpg
// module id = LZ+r
// module chunks = 1